import { AddIcon } from "@chakra-ui/icons";
import { ForwardedRef, forwardRef } from "react";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";

type Props = TooltipIconButtonProps;

function PlusButton(
  { label, ...rest }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <TooltipIconButton
      ref={ref}
      icon={<AddIcon />}
      label={label}
      colorScheme="pinkButton"
      fontSize="xs"
      borderRadius="2xl"
      p=".5em"
      minH="1.75em"
      pl={3}
      pr={3}
      {...rest}
    />
  );
}

export default forwardRef(PlusButton);
